import React from 'react';
import bem from 'utils/bem';
import { Formik } from 'formik';
import toast from 'react-hot-toast';
import Text from 'components/Text';
import { Button } from 'components/Button';
import FormikPhoneField from 'forms/fields/PhoneField/FormikPhoneField';
import PasswordField from 'forms/fields/PasswordField';
import Model from '../../../../model';

import './index.sass'

const { block, el } = bem('kz-login-form', 'form');

const defaultValues = {
    customerPhone: '',
    password: ''
};

const KZLoginForm = ({ switchToRegister, callback }) => {

    const { openResetPasswordForm, closeKZLoginForm } = Model.modal;
    const { authenticate } = Model.user;

    const handleSubmit = (values, form) => {
        const formData = new FormData();

        formData.append('username', values.customerPhone);
        formData.append('password', values.password);

        fetch('/login', {
            method: 'POST',
            body: formData
        }).then((promise) => {
            return promise.json();
        }).then((response) => {
            if (response.success) {
                authenticate({ username: response.user });
                closeKZLoginForm();
                callback();
            } else {
                toast.error('Неверное имя пользователя или пароль');
                form.setFieldValue('password', '');
                form.setSubmitting(false);
            }
        }).catch(err => {
            console.error(err);
            toast.error(err)
        });
    };

    const rForm = (form) => {
        const onClickSubmit = (e) => {
            e.preventDefault();
            form.submitForm();
        }

        return (
            <form className={block()} onSubmit={form.handleSubmit}>
                <div className={el('top-block')}>
                    <div className={el('title')}>
                        <Text serif>Вход в личный кабинет</Text>
                    </div>
                    <div className={el('middle-block')}>
                        <div className={el('fields')}>
                            <div className={el('username')}>
                                <FormikPhoneField
                                    className={el('customerPhone')}
                                    placeholder='Ваш номер телефона'
                                />
                            </div>
                            <div className={el('password')}>
                                <PasswordField
                                    name='password'
                                    placeholder='Пароль'
                                />
                            </div>
                        </div>
                        <div className={el('reset-password-block')}>
                            <div className={el('reset-password')} onClick={openResetPasswordForm}>
                                <Text>Забыли пароль?</Text>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={el('buttons')}>
                    <Button mod={'gold'} type='button' onClick={onClickSubmit} disabled={form.isSubmitting}>
                        <Text>Продолжить</Text>
                    </Button>
                    <div className={el('register-block')}>
                        <Text serif>Впервые у нас?</Text>
                        <Text className={el('register-link')} onClick={switchToRegister} serif>Регистрация</Text>
                    </div>
                </div>
            </form>
        )
    }

    return (
        <Formik
            initialValues={defaultValues}
            onSubmit={handleSubmit}
            validateOnChange={false}
            validateOnBlur={false}>
            {(form) => rForm(form)}
        </Formik>
    )
};

export default KZLoginForm;
